import styled from 'styled-components'

export const ShipmentContainer = styled.div`
  margin-bottom: 30px;
  padding-top: 10px;
`

export const ShipmentHeader = styled.h3`
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 20px;
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 16px;
  margin-bottom: 30px;
  @media (min-width: 600px) : {
    max-width: calc(100% - 175px);
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`

export const ShipmentDetail = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const DetailLabel = styled.span`
  flex: 0 0 115px;
`

export const DetailValue = styled.strong`
  flex: 1;
  text-transform: uppercase;
  max-width: calc(100% - 130px);
`

export const DetailLink = styled.a`
  color: ${({ theme }) => theme.colors.component.link};
`

export const ShipmentTrackingNumber = styled.p`
  margin: 0;
`

export const ShipmentItems = styled.div`
  margin-bottom: 0;
`
